




































import { Component, Prop, Vue, Inject, Watch } from "vue-property-decorator";
import { IHeightStyle } from "@/@types/styles/height";

@Component({})
export default class MenuDemo extends Vue {
  @Prop({ type: String, default: null }) name!: string;
  @Prop({ type: String, default: null }) img!: string;
  @Inject() readonly channel_images!: string;
  show = false;

  $refs!: {
    demo: HTMLElement;
  };

  mainHeight: IHeightStyle = {
    minHeight: "auto",
    maxHeight: "auto",
  };
  heightStyle: IHeightStyle = {
    minHeight: "",
    maxHeight: "",
  };

  @Watch("card")
  calculateHeight(): void {
    this.mainHeight.maxHeight = sessionStorage.getItem("demo-height") + "px";
    this.mainHeight.minHeight = sessionStorage.getItem("demo-height") + "px";
    this.show = true;
    this.$nextTick(() => {
      this.calculateDemoHeight();
    });
  }

  async calculateDemoHeight(): Promise<void> {
    this.heightStyle.minHeight = this.$refs.demo.clientWidth + "px";
    this.heightStyle.maxHeight = this.heightStyle.minHeight;
    console.log(this.heightStyle.maxHeight);
  }

  mounted(): void {
    window.addEventListener("resize", this.calculateDemoHeight);
    this.calculateHeight();
  }

  destroyed(): void {
    window.removeEventListener("resize", this.calculateDemoHeight);
  }
}
